"use client"

import { useCallback, useEffect, useMemo, useState } from "react"

import ImageGallery from "@modules/products/components/image-gallery"
import VirtualTryOnDrawer from "@modules/products/components/virtual-try-on"

const ProductMedia = ({ product }: { product: any }) => {
  const [virtualTryOnOpen, setVirtualTryOnOpen] = useState(false)
  const [variantImageUrl, setVariantImageUrl] = useState<string | null>(null)
  const isVirtualTryOnEnabled = useMemo(
    () => Boolean(product?.virtualTryOnEnabled && Array.isArray(product?.images) && product.images.length > 0),
    [product]
  )

  useEffect(() => {
    if (typeof window === "undefined") return
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ productId?: string; imageUrl?: string | null }>).detail
      if (!detail) return
      const productId = product?._id || product?.id || product?.slug
      if (detail.productId && productId && detail.productId !== productId) {
        return
      }
      const next =
        typeof detail.imageUrl === "string" && detail.imageUrl.trim().length
          ? detail.imageUrl.trim()
          : null
      setVariantImageUrl(next)
    }
    window.addEventListener("product-variant-image", handler as EventListener)
    return () => window.removeEventListener("product-variant-image", handler as EventListener)
  }, [product?._id, product?.id, product?.slug])

  useEffect(() => {
    setVariantImageUrl(null)
  }, [product?._id, product?.id, product?.slug])

  const handleOpenVirtualTryOn = useCallback(() => {
    if (isVirtualTryOnEnabled) {
      setVirtualTryOnOpen(true)
    }
  }, [isVirtualTryOnEnabled])

  const handleCloseVirtualTryOn = useCallback(() => {
    setVirtualTryOnOpen(false)
  }, [])

  return (
    <>
      <ImageGallery
        images={product?.images || []}
        product={product}
        variantImageUrl={variantImageUrl}
        virtualTryOnEnabled={isVirtualTryOnEnabled}
        onVirtualTryOn={handleOpenVirtualTryOn}
      />
      {isVirtualTryOnEnabled && (
        <VirtualTryOnDrawer open={virtualTryOnOpen} onClose={handleCloseVirtualTryOn} product={product} />
      )}
    </>
  )
}

export default ProductMedia
